"use client";

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import FacilityRequestModal from '@/components/common/FacilityRequestModal';
import ClinicianApplicationModal from '@/components/common/ClinicianApplicationModal';

export default function ContactClient() {
  const [facilityModalOpen, setFacilityModalOpen] = useState(false);
  const [clinicianModalOpen, setClinicianModalOpen] = useState(false);

  return (
    <>
      <div className="bg-gradient-medical text-white p-8 md:p-10 rounded-2xl shadow-2xl relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-center relative z-10 text-white">Quick Links</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
          <button
            onClick={() => setFacilityModalOpen(true)}
            className="flex items-center justify-between p-6 bg-white/10 rounded-xl hover:bg-white/20 transition-all border border-white/20 backdrop-blur-sm group"
          >
            <div className="text-left">
              <h4 className="text-lg font-semibold mb-1 text-white">Request Candidates</h4>
              <p className="text-sm text-white/80">For healthcare facilities</p>
            </div>
            <Icon name="ArrowRightIcon" size={20} className="group-hover:translate-x-2 transition-transform duration-300 text-white" />
          </button>
          <button
            onClick={() => setClinicianModalOpen(true)}
            className="flex items-center justify-between p-6 bg-white/10 rounded-xl hover:bg-white/20 transition-all border border-white/20 backdrop-blur-sm group"
          >
            <div className="text-left">
              <h4 className="text-lg font-semibold mb-1 text-white">Apply for Jobs</h4>
              <p className="text-sm text-white/80">For healthcare clinicians</p>
            </div>
            <Icon name="ArrowRightIcon" size={20} className="group-hover:translate-x-2 transition-transform duration-300 text-white" />
          </button>
        </div>
      </div>

      <FacilityRequestModal isOpen={facilityModalOpen} onClose={() => setFacilityModalOpen(false)} />
      <ClinicianApplicationModal isOpen={clinicianModalOpen} onClose={() => setClinicianModalOpen(false)} />
    </>
  );
}